import axios from 'axios';

export const url = process.env.REACT_APP_URL_END_POINT

let token = localStorage.getItem('token') || '';

const API = axios.create({
    baseURL: url,
    headers: { 'x-access-token': token },
    withCredentials: true
})

export const setToken = token => API.defaults.headers['x-access-token'] = token;
// ****** //

export const auth = values => API.post('/auth', values)

// ****** //
export const createBackUp = () => API.post('/backup');

// ****** //
export const getData = dir => API.get(`/${dir}`);

export const getPaginationData = (dir, page=1, size) => size ? API.get(`/${dir}/page/${page}/${size}`) : API.get(`/${dir}/page/${page}`);

export const createNew = (dir, data) => API.post(`/${dir}`, data)

export const editData = (dir, id, data) => API.patch(`/${dir}/${id}`, data)

export const deleteItem = (dir, id) => API.delete(`/${dir}/${id}` )

// ****** //
export const resetPassword = values => API.patch('/accounts', values)

// ****** //
export const getReport = (path) => API.get(`/reports/${path}`)

// ****** //
export const downloadPDF = (path, data) => API.post(`/createFile/${path}`, data)